var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalDuplicationFavoris",
      attrs: {
        size: "md",
        title: "Dupliquer les favoris",
        "ok-title": "Dupliquer",
        "ok-disabled": _vm.duplicationEnCours || !_vm.estValide,
        "cancel-title": "Annuler",
        "no-close-on-backdrop": ""
      },
      on: {
        show: function($event) {
          return _vm.init()
        },
        ok: function($event) {
          return _vm.dupliquer()
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", { attrs: { for: "selEtablissementsDestination" } }, [
              _vm._v("Établissements de destination")
            ]),
            _c("MultiSelect", {
              attrs: {
                id: "selEtablissementsDestination",
                value: _vm.destination.etablissementsIds,
                items: _vm.etablissementsCourants,
                itemText: "eRS",
                itemValue: "eId",
                placeholder: "Etablissements...",
                emptyText: "Tous les établissements ont été ajoutés"
              },
              on: {
                change: function($event) {
                  return _vm.majEtablissements($event)
                }
              }
            }),
            !_vm.destination.etablissementsIds.length
              ? _c("div", { staticClass: "error" }, [
                  _vm._v("Ce champ est requis")
                ])
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex-start" },
          [
            _c("ToggleButton", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: {
                    content:
                      "Attention, action irréversible qui supprimera tous les favoris présents sur le(les) établissement(s) de destination."
                  },
                  expression:
                    "{ content: 'Attention, action irréversible qui supprimera tous les favoris présents sur le(les) établissement(s) de destination.'}"
                }
              ],
              attrs: {
                name: "ecraserMenuDestination",
                id: "ecraserMenuDestination",
                height: 21,
                width: 60,
                labels: { checked: "Oui", unchecked: "Non" },
                color: { checked: "#ea0000de", unchecked: "#cccccc" }
              },
              model: {
                value: _vm.destination.ecraserFavorisExistants,
                callback: function($$v) {
                  _vm.$set(_vm.destination, "ecraserFavorisExistants", $$v)
                },
                expression: "destination.ecraserFavorisExistants"
              }
            }),
            _c("label", { attrs: { for: "ecraserMenuDestination" } }, [
              _c("i", { staticClass: "fas fa-exclamation-triangle ml-2" }),
              _vm._v(" Remplacer le(s) favori(s) de destination existant(s).")
            ])
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }